import React from 'react';
import { motion } from 'framer-motion';
interface CaseSlideShellProps {
  step: string;
  eyebrow: string;
  headline: React.ReactNode;
  intro?: React.ReactNode;
  surface?: boolean;
  children: React.ReactNode;
}

/** Shared layout for the Nordic case slides: numbered eyebrow, strong headline, content area. */
export function CaseSlideShell({
  step,
  eyebrow,
  headline,
  intro,
  surface = false,
  children
}: CaseSlideShellProps) {
  return <div className={`flex h-full w-full flex-col overflow-hidden px-[clamp(2rem,4.5vw,4.5rem)] pb-[clamp(3.5rem,5vw,4.5rem)] pt-[clamp(4rem,6vw,5.5rem)] ${surface ? 'bg-[var(--surface)]' : 'bg-[var(--bg)]'}`} data-id="element-162" data-mp="ziyqzhm59zhm">
      <motion.header initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="flex-shrink-0" data-id="element-163" data-mp="vgbuv4ifxsem">
        <p className="mb-2 text-[clamp(0.68rem,0.95vw,0.88rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-164" data-mp="3g6t1sidj8tsu">
          <span className="tabular-nums" data-id="element-165" data-mp="217nhclxhn8j3">{step}</span>
          <span className="mx-2 text-[var(--brand)]/40" data-id="element-166" data-mp="21a9myg0tjdyo">/</span>
          {eyebrow}
        </p>
        <h2 className="max-w-5xl text-[clamp(1.9rem,3.7vw,3.5rem)] font-extrabold leading-[1.02] tracking-[-0.04em] text-[var(--fg)]" data-id="element-167" data-mp="1wax0hwdv08wm">
          {headline}
        </h2>
        {intro && <p className="mt-[clamp(0.5rem,1vw,0.9rem)] max-w-3xl text-[clamp(0.85rem,1.2vw,1.15rem)] font-medium leading-snug text-[var(--muted)]" data-id="element-168" data-mp="265p2dceh5hx7">
            {intro}
          </p>}
      </motion.header>
      <div className="mt-[clamp(1rem,2vw,1.75rem)] flex min-h-0 flex-1 flex-col" data-id="element-169" data-mp="2f5vlbdsxza3r">
        {children}
      </div>
    </div>;
}